/* eslint-disable @typescript-eslint/no-explicit-any */
import { STORAGE } from "@/constants";

type StorageType = "local" | "session";

const getStorage = (type: StorageType): Storage => {
  return type === STORAGE.LOCAL ? localStorage : sessionStorage;
};

export const setItem = (
  key: string,
  value: any,
  type: StorageType = STORAGE.LOCAL,
): void => {
  try {
    const storage = getStorage(type);
    storage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error setting ${type}Storage item`, error);
  }
};

export const getItem = <T = any>(
  key: string,
  type: StorageType = STORAGE.LOCAL,
): T | null => {
  try {
    const storage = getStorage(type);
    const raw = storage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch (error) {
    console.error(`Error parsing ${type}Storage item`, error);
    return null;
  }
};

export const removeItem = (
  key: string,
  type: StorageType = STORAGE.LOCAL,
): void => {
  try {
    const storage = getStorage(type);
    storage.removeItem(key);
  } catch (error) {
    console.error(`Error removing ${type}Storage item`, error);
  }
};
